export default __webpack_public_path__ + "static/media/cross.1ca75aaf.svg";